"use client";
import React from "react";

const KbvOddsStatus = ({ trend }) => {
  let statusOdds = "";

  switch (trend) {
    case "decreased":
      statusOdds = "border-t-vibrant-red border-t-[0.54rem]";
      break;
    case "increased":
      statusOdds = "border-b-medium-green border-b-[0.54rem]";
      break;
  }

  return (
    <span
      className={`w-0 h-0 border-l-[0.3125rem] border-r-[0.3125rem] border-l-transparent border-r-transparent ${statusOdds}`}
    ></span>
  );
};

export default React.memo(KbvOddsStatus);
